// extracted by mini-css-extract-plugin
export default {"button":"button__kY9AT"};
    if(module.hot) {
      // 1788784362194
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  